import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { useAuthStore } from './store/authStore';
import { Layout } from './components/Layout/Layout';
import { LoginPage } from './pages/LoginPage';
import { ForgotPasswordPage } from './pages/ForgotPasswordPage';
import { ResetPasswordPage } from './pages/ResetPasswordPage';
import { DashboardPage } from './pages/DashboardPage';
import { ProjectsPage } from './pages/ProjectsPage';
import { ProjectDetailPage } from './pages/ProjectDetailPage';
import { MyTasksPage } from './pages/MyTasksPage';
import { TasksPage } from './pages/TasksPage';
import { MileagePage } from './pages/MileagePage';
import { TeamPage } from './pages/TeamPage';
import { ReportsPage } from './pages/ReportsPage';
import { FinancePage } from './pages/FinancePage';
import { AdminCompaniesPage } from './pages/AdminCompaniesPage';
import { SettingsPage } from './pages/SettingsPage';

function PrivateRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, hasHydrated } = useAuthStore();
  if (!hasHydrated) return null;
  return isAuthenticated ? <>{children}</> : <Navigate to="/login" replace />;
}

function FinanceRoute({ children }: { children: React.ReactNode }) {
  const { user, hasHydrated } = useAuthStore();
  if (!hasHydrated) return null;
  const canAccess = user?.role === 'finance' || user?.role === 'super_admin';
  return canAccess ? <>{children}</> : <Navigate to="/projects" replace />;
}

function App() {
  return (
    <Router>
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 3000,
          style: {
            borderRadius: '10px',
            background: '#F3F4F6',
            color: '#374151',
            border: '1px solid #E5E7EB',
          },
          success: {
            style: { background: '#C24914', color: '#FFFFFF', border: '1px solid #C24914' },
          },
          error: {
            style: { background: '#111827', color: '#FFFFFF', border: '1px solid #111827' },
          },
        }}
      />
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/register" element={<Navigate to="/login" replace />} />
        <Route
          path="/*"
          element={
            <PrivateRoute>
              <Layout>
                <Routes>
                  <Route path="/" element={<Navigate to="/projects" replace />} />
                  <Route path="/dashboard" element={<DashboardPage />} />
                  <Route path="/projects" element={<ProjectsPage />} />
                  <Route path="/projects/:id" element={<ProjectDetailPage />} />
                  <Route path="/my-tasks" element={<MyTasksPage />} />
                  <Route path="/mileage" element={<MileagePage />} />
                  <Route path="/tasks" element={<TasksPage />} />
                  <Route path="/team" element={<TeamPage />} />
                  <Route path="/reports" element={<ReportsPage />} />
                  <Route path="/finance" element={<FinanceRoute><FinancePage /></FinanceRoute>} />
                  <Route path="/admin/companies" element={<AdminCompaniesPage />} />
                  <Route path="/settings" element={<SettingsPage />} />
                </Routes>
              </Layout>
            </PrivateRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
